import { CustomerInterface } from "@contracts/interfaces/customer.interface";

export class CustomerFactory {
  public static newCustomer(): CustomerInterface {
    return {
      name: "",
      phone: "",
      phone2: "",
      email: "",
      address: "",
      remoteID: "",
      notes: "",
      googleReviewSMS: []
    };
  }

  public static validate(customer: any): CustomerInterface {
    if (!customer) {
      return this.newCustomer();
    }

    const validated: CustomerInterface = {
      name: customer.name || "",
      phone: customer.phone || "",
      phone2: customer.phone2 || "",
      email: customer.email || "",
      address: customer.address || "",
      remoteID: customer.remoteID || "",
      notes: customer.notes || "",
      googleReviewSMS: Array.isArray(customer.googleReviewSMS) ? customer.googleReviewSMS : [],
      tags: Array.isArray(customer.tags) ? customer.tags : customer.tags ? [customer.tags] : undefined,
      abn: customer.abn,
      business: customer.business,
      owner: customer.owner,
      ndis: customer.ndis,
      driversLicenseNumber: customer.driversLicenseNumber,
      bankAccNumber: customer.bankAccNumber,
      bankBSBNumber: customer.bankBSBNumber
    };

    if (customer._id) {
      validated._id = String(customer._id);
    }

    return validated;
  }
}
